import { FC } from 'react';

import { IconProps } from './types';

export const CompanyIcon: FC<IconProps> = ({
	color = '#06519E',
	height = 24,
	size,
	width = 24,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
	>
		<path
			fill={color}
			d="M13.82 7.455h-3.636a.91.91 0 0 1 0-1.819h3.636a.909.909 0 1 1 0 1.819zM10.184 11.09h3.636a.909.909 0 1 0 0-1.817h-3.636a.91.91 0 0 0 0 1.818zM13.82 14.727h-3.636a.909.909 0 1 1 0-1.818h3.636a.908.908 0 1 1 0 1.818zM10.184 18.364h3.636a.908.908 0 1 0 0-1.819h-3.636a.909.909 0 1 0 0 1.819z"
			fillRule="evenodd"
		/>
		<path
			fill={color}
			d="M17.457 22H4.729a2.73 2.73 0 0 1-2.727-2.727v-5.44a4.03 4.03 0 0 1 .083-.946c.118-.457.322-.822.602-1.102a2.344 2.344 0 0 1 1.068-.6c.359-.094.7-.094.974-.094h.91V4.727c0-.274 0-.615.092-.972.183-.806.841-1.47 1.671-1.667C7.517 2.06 7.767 2 9.275 2h6.363c.275 0 .616 0 .973.093.806.182 1.47.84 1.666 1.67.089.352.089.692.089.964v3.637h.909c.286-.01.614.017.93.082l.044.01c.413.109.778.312 1.058.591.288.288.496.658.602 1.073.093.355.093.682.093.97v8.183A2.73 2.73 0 0 1 19.275 22H17.457zm-.91-1.818h-9.09V4.727c0-.197 0-.383.04-.543a.432.432 0 0 1 .308-.323c.01-.002.262-.043 1.47-.043h6.363c.199 0 .385 0 .545.041.159.036.287.164.328.335.036.146.036.334.036.533v15.455zm1.819 0h.909a.91.91 0 0 0 .909-.91v-8.181c0-.206 0-.384-.035-.516a.503.503 0 0 0-.126-.241.52.52 0 0 0-.213-.113 2.193 2.193 0 0 0-.503-.04h-.941v10zm-12.728 0v-7.273H4.73c-.197 0-.383 0-.517.035a.51.51 0 0 0-.24.127.51.51 0 0 0-.117.23c-.027.13-.041.308-.035.485v5.487c0 .502.408.909.91.909h.908z"
			fillRule="evenodd"
		/>
	</svg>
);
